// extracted by mini-css-extract-plugin
module.exports = {"container":"We","list":"Xe"};